import * as React from "react";
import { forwardRef } from "react";
const SvgBurger = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M1.2 13.2h21.6c0.662 0 1.2-0.538 1.2-1.2s-0.538-1.2-1.2-1.2h-21.6c-0.662 0-1.2 0.538-1.2 1.2s0.538 1.2 1.2 1.2zM1.2 6h21.6c0.662 0 1.2-0.538 1.2-1.2s-0.538-1.2-1.2-1.2h-21.6c-0.662 0-1.2 0.538-1.2 1.2s0.538 1.2 1.2 1.2zM1.2 20.4h21.6c0.662 0 1.2-0.538 1.2-1.2s-0.538-1.2-1.2-1.2h-21.6c-0.662 0-1.2 0.538-1.2 1.2s0.538 1.2 1.2 1.2z" }));
const ForwardRef = forwardRef(SvgBurger);
export { ForwardRef as ReactComponent };
